import styled from 'styled-components';

const NoLiveEventSC = styled.div`
  display: flex;
  align-items: center;
  column-gap: 32px;
  padding: 24px;
  width: 100%;
  border-radius: 4px;
  border: 1.5px dashed #a9c7e9;

  @media ${({ theme }) => theme.device.mobileL} {
    align-items: flex-start;
  }
`;

export { NoLiveEventSC };
